import { render, staticRenderFns } from "./SIdentify.vue?vue&type=template&id=f177cd88&scoped=true&"
import script from "./SIdentify.vue?vue&type=script&lang=js&"
export * from "./SIdentify.vue?vue&type=script&lang=js&"
import style0 from "./SIdentify.vue?vue&type=style&index=0&id=f177cd88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f177cd88",
  null
  
)

export default component.exports